export enum COLLABORATOR_STATUS {
  ADMINISTRATOR = 'ADMINISTRATOR',
  EMPLOYEE = 'EMPLOYEE'
}

export enum COLLABORATOR_TYPE {
  INVITATION = 'INVITATION',
  EMPLOYEE = 'EMPLOYEE'
}
